import VisibilityRounded from "@mui/icons-material/VisibilityRounded";

export const visibilityOn = ({ size = 15, color = "white" }) => {
  return <VisibilityRounded />;
};
